export default __webpack_public_path__ + "static/media/img-store-coffee-tabs.8163dd6f.png";